module.exports = __webpack_public_path__ + "img/SCIENTIFIC_GAMES.e38908ab.png";